module.exports = __webpack_public_path__ + "static/media/bronze-cup-icon.b8487d77.svg";